import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import { makeStyles } from "@material-ui/styles";
import { PropsWithChildren } from "react-transition-group/node_modules/@types/react";

const useStyles = makeStyles(() => ({
  root: (props: SvgIconProps) => ({
    width: props.width,
    height: props.height,
  }),
}));

function initViewBox(viewBoxConfig: { width?: number; height?: number }): string {
  const viewBox: Record<string, number> = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24,
  };
  Object.entries(viewBoxConfig).forEach(([key, val]) => {
    if (key && val) {
      const min = key === "width" ? "minX" : "minY";
      viewBox[min] = (viewBox[key] - val) / 2;
      viewBox[key] = val;
    }
  });
  return Object.values(viewBox).join(" ");
}

function CroppedSvgIcon(props: PropsWithChildren<SvgIconProps & { width?: number; height?: number }>) {
  const { children, width, height } = props;
  const classes = useStyles(props);

  return (
    <SvgIcon {...props} classes={classes} viewBox={initViewBox({ width, height })}>
      {children}
    </SvgIcon>
  );
}

export default CroppedSvgIcon;
